import { render } from "./IInvestedStandardListPanel.vue?vue&type=template&id=40bbe69f&scoped=true&ts=true"
import script from "./IInvestedStandardListPanel.vue?vue&type=script&lang=ts"
export * from "./IInvestedStandardListPanel.vue?vue&type=script&lang=ts"

import "./IInvestedStandardListPanel.vue?vue&type=style&index=0&id=40bbe69f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bbe69f"]])

export default __exports__